import { DeepReadonly, IFormat } from 'types';
import { deepFreeze } from '../utils/deepFreeze.js';

export const defaultFormatTypes: DeepReadonly<IFormat[]> = deepFreeze([
  {
    display: 'Date (A valid moment date format)',
    shieldFormat: 'YYYY-MM-DD',
    type: 'MOMENT_DATE',
    uniFormat: 'MOMENT_DATE',
  },
  {
    type: 'DATE',
    uniFormat: 'D.M.YYYY',
    shieldFormat: 'YYYY-MM-DD',
    display: 'DD.MM.YYYY',
  },
  {
    type: 'DATE2',
    uniFormat: 'D-M-YYYY',
    shieldFormat: 'YYYY-MM-DD',
    display: 'DD-MM-YYYY',
  },
  {
    type: 'DATE3',
    uniFormat: 'D-MMM-YY',
    shieldFormat: 'YYYY-MM-DD',
    display: 'DD-MMM-YY',
  },
  {
    type: 'DATE6',
    uniFormat: 'D-MMM-YYYY',
    shieldFormat: 'YYYY-MM-DD',
    display: 'DD-MMM-YYYY',
  },
  {
    type: 'DATE7',
    uniFormat: 'D/M/YYYY',
    shieldFormat: 'YYYY-MM-DD',
    display: 'DD/MM/YYYY',
  },
  {
    type: 'DATE8',
    uniFormat: 'YYYY-MM-DDThh:mm:ss',
    shieldFormat: 'YYYY-MM-DD',
    display: 'YYYY-MM-DDThh:mm:ss',
  },
  {
    type: 'DATE9',
    uniFormat: 'MMM D, YYYY',
    shieldFormat: 'YYYY-MM-DD',
    display: 'MMM DD, YYYY',
  },
  {
    type: 'MAP',
    uniFormat: 'TEXT_OR_BLANK',
    shieldFormat: 'BOOLEAN',
    display: 'MAP (return as boolean)',
  },
  {
    type: 'MAP2',
    uniFormat: 'TEXT_OR_BLANK',
    shieldFormat: 'TEXT',
    display: 'MAP (return as string)',
  },
  {
    type: 'MAP3',
    uniFormat: 'TEXT_OR_BLANK',
    shieldFormat: 'NUMBER',
    display: 'MAP (return as number)',
  },
  {
    type: 'GENDER',
    uniFormat: {
      male: 'M',
      female: 'F',
      other: 'O',
    },
    shieldFormat: {
      male: 'Male',
      female: 'Female',
      other: 'Other',
    },
    display: 'Gender - single character (M or F or O)',
  },
  {
    type: 'GENDER2',
    uniFormat: {
      male: 'Male',
      female: 'Female',
      other: 'Other',
    },
    shieldFormat: {
      male: 'Male',
      female: 'Female',
      other: 'Other',
    },
    display: 'Gender - (Male / Female / Other)',
  },
  {
    type: 'TEXT',
    uniFormat: 'TEXT',
    shieldFormat: 'TEXT',
    display: 'Text',
  },
  {
    type: 'TEXT_OR_BLANK',
    uniFormat: 'TEXT_OR_BLANK',
    shieldFormat: 'TEXT_OR_BLANK',
    display: 'Text OR Blank',
  },
  {
    type: 'TRUE_OR_FALSE',
    uniFormat: {
      true: 'TRUE',
      false: 'FALSE',
    },
    shieldFormat: {
      true: true,
      false: false,
    },
    display: 'TRUE or FALSE',
  },
  {
    type: 'Y_OR_N',
    uniFormat: {
      true: 'Y',
      false: 'N',
    },
    shieldFormat: {
      true: true,
      false: false,
    },
    display: 'Single character (Y or N)',
  },
  {
    type: 'YES_OR_NO',
    uniFormat: {
      true: 'Yes',
      false: 'No',
    },
    shieldFormat: {
      true: true,
      false: false,
    },
    display: '"Yes" or "No"',
  },
  {
    type: 'NUMBER',
    uniFormat: 'TEXT',
    shieldFormat: 'NUMBER',
    display: 'Number',
  },
  {
    type: 'ABS_NUMBER',
    uniFormat: 'TEXT',
    shieldFormat: 'ABS_NUMBER',
    display: 'Absolute Number (Positive)',
  },
  {
    type: 'ISO-3166-1 ALPHA-2 (Nationality)',
    uniFormat: 'ISO-3166-1 ALPHA-2 (Nationality)',
    shieldFormat: 'ISO-3166-1 ALPHA-2 (Nationality)',
  },
  {
    type: 'ISO-3166-1 ALPHA-3 (Nationality)',
    uniFormat: 'ISO-3166-1 ALPHA-3 (Nationality)',
    shieldFormat: 'ISO-3166-1 ALPHA-3 (Nationality)',
  },
  {
    type: 'ISO-3166-1 ALPHA-2 (Country)',
    uniFormat: 'ISO-3166-1 ALPHA-2 (Country)',
    shieldFormat: 'ISO-3166-1 ALPHA-2 (Country)',
  },
  {
    type: 'ISO-3166-1 ALPHA-3 (Country)',
    uniFormat: 'ISO-3166-1 ALPHA-3 (Country)',
    shieldFormat: 'ISO-3166-1 ALPHA-3 (Country)',
  },
  {
    type: 'REGEX',
    uniFormat: 'TEXT',
    shieldFormat: 'NUMBER',
    display: 'Regex (return as number)',
  },
  {
    type: 'REGEX2',
    uniFormat: 'TEXT',
    shieldFormat: 'TEXT',
    display: 'Regex (return as text)',
  },
  {
    type: 'REGEX3',
    uniFormat: 'TEXT',
    shieldFormat: 'BOOLEAN',
    display: 'Regex (return as boolean)',
  },
  {
    type: 'PADZERO8',
    uniFormat: 'TEXT',
    shieldFormat: 'TEXT',
    display: '8 Chars - Padded with 0',
  },
  {
    type: 'PADZERO9',
    uniFormat: 'TEXT',
    shieldFormat: 'TEXT',
    display: '9 Chars - Padded with 0',
  },
  {
    type: 'BLANK_IF_REGEX_CONDITION',
    uniFormat: 'TEXT_OR_BLANK',
    shieldFormat: 'TEXT_OR_BLANK',
    display: 'Blank if regex condition returns a value',
  },
  {
    type: 'DEFAULT_IF_REGEX_CONDITION',
    uniFormat: 'TEXT_OR_BLANK',
    shieldFormat: 'TEXT_OR_BLANK',
    display: 'Default if regex condition returns a value',
  },
  {
    type: 'MULTI_COLUMN',
    uniFormat: 'MULTI_COLUMN',
    shieldFormat: 'MULTI_COLUMN',
    display: 'Multi-column selection (concatenated)',
  },
]);
